module.exports = __webpack_public_path__ + "img/social-icon-instagram-white.f7c72b3e.svg";